import {Type} from '@angular/core';

import {BaseFilter} from './base/base.filter';

export class AuctionFilter extends BaseFilter {

    public description: string | undefined;

    public constructor() {
        super();
    }

    protected getType(): Type<BaseFilter> {
        return AuctionFilter;
    }
}
